const USS_ONLY_MODULES = new Set(["scenario_tracker"]);
const USS_COMPANY_IDS = new Set(["uss"]);

export const normalizeModuleId = (moduleId: string) =>
  moduleId.toLowerCase().replace(/-/g, "_");

export function isCompanyAllowedForModule(
  companyId: string | null | undefined,
  moduleId: string,
): boolean {
  const normalizedModuleId = normalizeModuleId(moduleId);
  if (!USS_ONLY_MODULES.has(normalizedModuleId)) {
    return true;
  }

  return USS_COMPANY_IDS.has((companyId || "").toLowerCase());
}

export function shouldUseScopedModuleStats(moduleId: string): boolean {
  return USS_ONLY_MODULES.has(normalizeModuleId(moduleId));
}

export function filterModulesForCompany(
  companyId: string | null | undefined,
  moduleIds: string[],
): string[] {
  return moduleIds.filter((moduleId) =>
    isCompanyAllowedForModule(companyId, moduleId)
  );
}
